import React, { useEffect, useState }  from 'react';

import DashboardContainer from '../../components/admin/DashboardContainer'

import Calendar from '../../components/calendar/Calendar'
import CompanyList from '../../components/calendar/CompanyList'

import { supabase } from '../../supabaseClient';

export default function CalendarAdmin() {
    const [sessions, setSessions] = useState([]);

    const fetchSessions = async () => {
        const { data: sessionsData, error: sessionsError } = await supabase
          .from('sessions')
          .select(`*, company:companies(*)`);

        if (sessionsError) {
          console.error('Error fetching sessions:', sessionsError);
        } else {
          setSessions(sessionsData);
        }
    };

    useEffect(() => {
      fetchSessions();
    }, []);

  return (
    <DashboardContainer title={'Calendario'}>

        <Calendar sessions={sessions}/>
        <CompanyList />
      
    </DashboardContainer>
  );
}